import {
  CoachAvailabilityStatusesEnum,
  GetCoachesByGeoQuery,
  SportsEnum,
} from 'types/generated/client';
import { GetCityCoachesQuery } from 'types/generated/server';
import { CoachType } from './props';
import PaddleIcon from 'svg/PaddleIcon';
import PickleRacket from 'svg/PickleRacket';
import Racket from 'svg/Racket';

// Type for coaches from the instant book query

export const isCoachProfile = (
  coach: any,
): coach is GetCoachesByGeoQuery['userProfiles'][0] | GetCityCoachesQuery['userProfiles'][0] => {
  return !!(coach as any).username || !!(coach as any).profile?.username;
};

/**
 * Determines if a coach qualifies for instant booking based on:
 * 1. Payment method connected (stripeMerchantChargesEnabled is true)
 * 2. Has at least one active availability slot
 */
export const isInstantBookEligible = (coach: GetCoachesByGeoQuery['userProfiles'][0]): boolean => {
  const hasPaymentMethod = Boolean(coach.stripeMerchantChargesEnabled);

  const hasActiveAvailability = Boolean(
    coach.coachAvailability?.some(
      (availability) => availability.status === CoachAvailabilityStatusesEnum.Active,
    ),
  );

  return hasPaymentMethod && hasActiveAvailability;
};

/**
 * Checks if a coach has an uploaded photo (not a placeholder).
 */
export const coachHasPhoto = (coach: CoachType): boolean => {
  if (isCoachProfile(coach)) {
    return Boolean(coach.profileImagePath);
  }
  return Boolean(coach.profileImageUrl || coach.aboutPhotoImageUrl || coach.logoImageUrl);
};

export const VENUE_DISTANCE_IMPERIAL_OPTIONS = [
  {
    name: '10 miles',
    id: 10,
  },
  {
    name: '25 miles',
    id: 25,
  },
  {
    name: '50 miles',
    id: 50,
  },
  {
    name: '100 miles',
    id: 100,
  },
];

export const DEFAULT_COURT_DISTANCE_IMPERIAL = VENUE_DISTANCE_IMPERIAL_OPTIONS[1];

export const getSports = (compact = false) => {
  const iconClass = compact ? 'h-[18px] w-[18px]' : 'h-6 w-6 max-sm:h-5 max-sm:w-5';
  return [
    {
      label: 'Pickleball',
      value: SportsEnum.Pickleball,
      icon: <img src="/images/programming/pickleball.png" className={iconClass} />,
    },
    {
      label: 'Tennis',
      value: SportsEnum.Tennis,
      icon: <img src="/images/programming/tennis.png" className={iconClass} />,
    },
    {
      label: 'Padel',
      value: SportsEnum.Padel,
      icon: <img src="/images/programming/padel.png" className={iconClass} />,
    },
  ];
};
